




















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import AccountCounters from '@/components/accounts/AccountCounters.vue';
import BillingReportComponent from '@/components/billing/BillingReportComponent.vue';
import AccountRatesComponent from '@/components/accounts/AccountRatesComponent.vue';
import { Account } from '@/modules/backend/Entities/Account';
import { AccountsModule } from '@/store/dashboard/accounts/AccountsModule';
import { resolveModule } from '@/store';

@Component({
  components: {
    counters: AccountCounters,
    report: BillingReportComponent,
    rates: AccountRatesComponent
  }
})
export default class AccountComponent extends Vue {
  private readonly accountsModule: AccountsModule = resolveModule(AccountsModule);

  @Prop({ required: true, type: Number }) private readonly accountId!: number;

  private get currentAccount(): Account | undefined {
    return this.accountsModule.AccountById(Number(this.accountId));
  }

  public async mounted(): Promise<void> {
    if (this.accountId) {
      await this.accountsModule.FetchSingle(Number(this.accountId));
    }
  }
}
